import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const sharedCoreJa = {
  columns: {
    id: "ID",
    name: commonShortFieldLabels.name,
    code: commonShortFieldLabels.code,
    actions: "操作",
    requestId: "オーケストレーションID",
    status: commonShortNouns.status,
    latestTask: "最新タスク",
    relatedTaskCount: "関連タスク数",
    createdBy: commonShortFieldLabels.createdBy,
    createdAt: commonShortFieldLabels.createdAt,
    updatedBy: commonShortFieldLabels.updatedBy,
    updatedAt: commonShortFieldLabels.updatedAt,
    operator: "操作ユーザー",
    vmId: "VM ID",
    accessEndpoint: "アクセスエンドポイント",
    destroyedAt: "破棄日時",
    failureCode: "失敗コード",
  },
  values: {
    expired: "期限切れ",
    accessMethodWeb: "Web",
    accessMethodSsh: "SSH",
    accessMethodRdp: "RDP",
    accessMethodVnc: "VNC",
    accessMethodPortMapping: "ポートマッピング",
    noAccessEndpoints: "利用可能なアクセス先はありません",
    workspaceAccessOnly: "実行ノードからのみアクセス可能",
    undefinedSource: "未定義ソース",
    runtimePublicHost: "ランタイム公開ホスト",
    runtimePublicHostHelp:
      "コントロールプレーンが node-runtime に逆方向接続するときに使うホスト名またはアドレスです。runtime_base_url はこの値と runtime_addr から導出されます。",
    providerTypeLocal: "ローカル",
    providerTypeCenter: "アセットセンター",
    executionProviderTypeLocal: "ローカル実行",
    executionProviderTypeCenter: "実行基盤",
    providerTypeLocalRuntime: "ローカルランタイム",
    providerKeyLocalRuntimeDocker: "ローカルランタイム Docker",
    providerKeyLocalRuntimeKvm: "ローカルランタイム KVM",
    providerKeyAliyunAckContainer: "Aliyun ACK Container",
    providerKeyAliyunEcsKvm: "Aliyun ECS KVM",
    providerKeyUnknown: "未定義の提供元",
    providerPhaseTargetBusiness: "目標状態",
    providerPhaseTargetIdentity: "統一アイデンティティ連携済み",
    providerPhaseTargetAsset: "アセットセンター連携済み",
    providerPhaseTargetExecution: "実行基盤連携済み",
    providerPhaseTransition: "移行中",
    providerPhaseLegacy: "レガシーモード",
    providerPhaseDisabled: "未有効化",
  },
  legend: {
    retryableFailed: "再試行可能失敗",
  },
  forms: {
    imagePlaceholder: "イメージ名。例: ghcr.io/example/app:1.0.0",
    imageRequired: "イメージ名を入力してください",
  },
  messages: {
    invalidPort: "ポートは 1〜65535 の整数でなければなりません",
  },
  parameterFields: {
    item: "パラメータ項目 #{index}",
    name: "フィールド名",
    label: "表示ラベル",
    type: "フィールド種別",
    options: "選択肢",
    optionsHint: "例: a,b,c",
    required: "必須",
    sensitive: "機密",
    description: "説明",
  },
  fields: {
    description: "説明",
  },
  applicationContract: {
    requiredParameterFieldName: "パラメータ項目名を入力してください",
    addParameterField: "パラメータ項目を追加",
    actionItem: "アクション #{index}",
    actionName: "アクション名",
    requiredActionName: "アクション名を入力してください",
    actionLabel: "アクションラベル",
    actionEntrypoint: "アクション入口",
    actionOutputKey: "出力キー",
    actionDescription: "アクション説明",
    addActionInputField: "アクション入力項目を追加",
    addActionItem: "アクションを追加",
    outputItem: "出力 #{index}",
    outputKey: "出力キー",
    outputLabel: "出力ラベル",
    outputType: "出力タイプ",
    outputFromAction: "元アクション",
    outputDescription: "出力説明",
    addOutputItem: "出力を追加",
  },
} as const;
